import { Link } from "react-router-dom";
import { gewerbegebietePages } from "@/data/gewerbegebietePages";

const cities = [
  { name: "Gewerbefläche mieten Berlin", slug: "gewerbeflaeche-mieten-berlin" },
  { name: "Gewerbefläche mieten Hamburg", slug: "gewerbeflaeche-mieten-hamburg" },
  { name: "Gewerbefläche mieten München", slug: "gewerbeflaeche-mieten-muenchen" },
  { name: "Gewerbefläche mieten Frankfurt", slug: "gewerbeflaeche-mieten-frankfurt" },
  { name: "Gewerbefläche mieten Köln", slug: "gewerbeflaeche-mieten-koeln" },
  { name: "Gewerbefläche mieten Düsseldorf", slug: "gewerbeflaeche-mieten-duesseldorf" },
  { name: "Gewerbeimmobilien Leipzig", slug: "leipzig-gewerbeimmobilien" },
  { name: "Gewerbeimmobilien Stuttgart", slug: "stuttgart-gewerbeimmobilien" },
];

const topGewerbegebiete = gewerbegebietePages
  .filter((p) => !p.isGeneric)
  .sort((a, b) => b.volume - a.volume)
  .slice(0, 6);

export const CityLinks = () => {
  return (
    <>
      <div className="mt-6 p-4 bg-card border rounded-lg">
        <h3 className="text-sm font-semibold text-foreground mb-3">
          Gewerbeflächen nach Stadt
        </h3>
        <ul className="space-y-2">
          {cities.map((city) => (
            <li key={city.slug}>
              <Link
                to={`/${city.slug}`}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                {city.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-4 p-4 bg-card border rounded-lg">
        <h3 className="text-sm font-semibold text-foreground mb-3">
          Gewerbegebiete entdecken
        </h3>
        <ul className="space-y-2">
          {topGewerbegebiete.map((page) => (
            <li key={page.slug}>
              <Link
                to={`/${page.slug}`}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Gewerbegebiet {page.locationName}
              </Link>
            </li>
          ))}
        </ul>
        <Link
          to="/gewerbegebiete-deutschland"
          className="inline-block mt-3 text-xs text-primary hover:underline"
        >
          → Alle Gewerbegebiete anzeigen
        </Link>
      </div>

      <div className="mt-4 p-4 bg-card border rounded-lg">
        <h3 className="text-sm font-semibold text-foreground mb-3">
          Weitere Angebote
        </h3>
        <ul className="space-y-2">
          <li><Link to="/lagerhalle-mieten" className="text-sm text-muted-foreground hover:text-primary transition-colors">Lagerhalle mieten</Link></li>
          <li><Link to="/ladenflaeche-mieten" className="text-sm text-muted-foreground hover:text-primary transition-colors">Ladenfläche mieten</Link></li>
          <li><Link to="/geschaeftsraeume-mieten" className="text-sm text-muted-foreground hover:text-primary transition-colors">Geschäftsräume mieten</Link></li>
          <li><Link to="/berechnung-von-miete" className="text-sm text-muted-foreground hover:text-primary transition-colors">Mietpreisrechner</Link></li>
          <li><Link to="/gewerbeversicherungen-vergleich" className="text-sm text-muted-foreground hover:text-primary transition-colors">Gewerbeversicherungen</Link></li>
        </ul>
      </div>
    </>
  );
};
